/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedBusinessSettings
 */
export interface PatchedBusinessSettings {
    /**
     * 
     * @type {string}
     * @memberof PatchedBusinessSettings
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedBusinessSettings
     */
    point_of_contact_first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedBusinessSettings
     */
    point_of_contact_last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedBusinessSettings
     */
    point_of_contact_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedBusinessSettings
     */
    point_of_contact_email?: string;
    /**
     * The phone number of the business admin, in e.164 format. This user will have admin access to the business portal.
     * @type {string}
     * @memberof PatchedBusinessSettings
     */
    portal_admin?: string;
    /**
     * A list of phone numbers in e.164 format for business managers who should have access to the business portal.
     * @type {Array<string>}
     * @memberof PatchedBusinessSettings
     */
    portal_managers?: Array<string>;
}

/**
 * Check if a given object implements the PatchedBusinessSettings interface.
 */
export function instanceOfPatchedBusinessSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchedBusinessSettingsFromJSON(json: any): PatchedBusinessSettings {
    return PatchedBusinessSettingsFromJSONTyped(json, false);
}

export function PatchedBusinessSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedBusinessSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'point_of_contact_first_name': !exists(json, 'point_of_contact_first_name') ? undefined : json['point_of_contact_first_name'],
        'point_of_contact_last_name': !exists(json, 'point_of_contact_last_name') ? undefined : json['point_of_contact_last_name'],
        'point_of_contact_phone': !exists(json, 'point_of_contact_phone') ? undefined : json['point_of_contact_phone'],
        'point_of_contact_email': !exists(json, 'point_of_contact_email') ? undefined : json['point_of_contact_email'],
        'portal_admin': !exists(json, 'portal_admin') ? undefined : json['portal_admin'],
        'portal_managers': !exists(json, 'portal_managers') ? undefined : json['portal_managers'],
    };
}

export function PatchedBusinessSettingsToJSON(value?: PatchedBusinessSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'point_of_contact_first_name': value.point_of_contact_first_name,
        'point_of_contact_last_name': value.point_of_contact_last_name,
        'point_of_contact_phone': value.point_of_contact_phone,
        'point_of_contact_email': value.point_of_contact_email,
        'portal_admin': value.portal_admin,
        'portal_managers': value.portal_managers,
    };
}

